<ng-template #preTitleTpl>
	<ng-content select="[pre-title]"></ng-content>
</ng-template>
<ng-template #content>
	<ng-content></ng-content>
</ng-template>
<ng-template #postTitleTpl>
	<ng-content select="[post-title]"></ng-content>
</ng-template>
